import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { interval, filter } from 'rxjs';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class UpdateVersionService {

  constructor(public updates: SwUpdate, private dialog: MatDialog) {
    if (updates.isEnabled) {
      interval(10 * 60000).subscribe(() => updates.checkForUpdate());
    }
  }

  public checkForUpdates(): void {
    this.updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => this.verifyType(evt.type)))
      .subscribe(() => this.openDialog());
  }
  
  private verifyType(type: string): boolean {
    return type === 'VERSION_READY' || type === 'VERSION_INSTALLATION_FAILED';
  }

  private openDialog(): void {
    const dialogOpened = this.dialog.getDialogById('updateVersionDialog');

    if (!dialogOpened) {
      const dialogConfirmRef = this.dialog.open(DialogConfirmComponent, {
        id: 'updateVersionDialog',
        disableClose: true,
        data: { 
          title: 'Atualizar Versão', 
          html: 'Nova versão do PasseLivre disponível.',
          confirmButtonText: 'Atualizar' 
        }
      });

      dialogConfirmRef.afterClosed().subscribe((confirm: boolean) => {
        if (confirm) {
          this.clear();
        }
      });
    }
  }

  private async clear() {
    const names = await caches.keys();
    names.forEach(name => caches.delete(name));

    if(window.navigator && navigator.serviceWorker) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      registrations.forEach(registration => registration.unregister());
    }

    document.location.reload()
  }
}